import React from 'react';
import { IconProps } from '.';

const SvgColoredTip = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#4769F7'
        d='M.267 9.292h3.468v9.375h2.329V9.292h3.468V7.354H.267v1.938ZM13.33 7.354h-2.345v11.313h2.344V7.354ZM15.236 18.667h2.343v-3.688h2.031c2.61 0 4.11-1.554 4.11-3.812 0-2.227-1.477-3.813-4.047-3.813h-4.437v11.313Zm2.343-5.578V9.276h1.656c1.391.008 2.07.766 2.063 1.89.008 1.141-.672 1.923-2.063 1.923H17.58Z'
      />
    </svg>
  );
};

export default SvgColoredTip;
